import styled from '@emotion/styled'

export const Modal = styled('div')`
  background-color: white;
  border-radius: 12px;
  min-height: 412px;
  left: 50%;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 550px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  box-sizing: border-box;
  z-index: 2;

  @media (max-width: 600px) {
    width: calc(100vw - 24px);
    min-height: auto;
    border-radius: 16px;
  }
`
